import { render, staticRenderFns } from "./SLRPerson0And4.vue?vue&type=template&id=0b6a830c"
import script from "./SLRPerson0And4.vue?vue&type=script&lang=js"
export * from "./SLRPerson0And4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports